<template>
  <section class="hero">
    <div class="hero-content">
      <h1>Foire aux questions</h1>
      <p>Nous répondons à vos questions!</p>
    </div>
  </section>
  <section class="page-container page-content faq">
    <article
      v-for="(item, index) in faqs"
      :key="index"
    >
      <h3 @click="toggle(index)">{{ item.question }}</h3>

      <div
        class="faq-body"
        :class="{ open: openIndex === index }"
      >
        <p>{{ item.answer }}</p>
      </div>
    </article>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const openIndex = ref(null)

function toggle(index) {
  openIndex.value = openIndex.value === index ? null : index
}

const faqs = [
  {
    question: "Qui est EasyGO ?",
    answer:
      "EasyGO est une application qui accompagne les compagnies de transport en Afrique en facilitant la communication avec les voyageurs et en simplifiant l'accès aux informations essentielles liées aux trajets.",
  },
  {
    question: "Comment rechercher un trajet ?",
    answer:
      "Depuis la page d'accueil, saisissez votre ville de départ, votre destination et la date souhaitée. Les trajets disponibles s'affichent avec les horaires, les compagnies et les tarifs, dans une fourchette d'un jour avant et après la date choisie. Cliquez sur un trajet pour consulter son détail et procéder à la réservation.",
  },
  {
    question: "Comment acheter un ticket ?",
    answer:
      "Une fois votre trajet sélectionné, choisissez le nombre de places souhaité, puis sélectionnez le moyen de paiement mobile de votre choix. Le paiement est sécurisé par notre prestataire NotchPay. Votre ticket vous est ensuite envoyé par e-mail, ou votre code de validation par SMS. Si vous disposez d'un compte, votre ticket sera également accessible dans votre carnet d’eTickets.",
  },
  {
    question: "Dois-je créer un compte pour utiliser EasyGO ?",
    answer:
      "La consultation des trajets est accessible sans compte. En revanche, pour conserver vos tickets, suivre vos réservations et accéder à votre historique de voyages, la création d’un compte est nécessaire. L’inscription est rapide et gratuite.",
  },
  {
    question: "Où retrouver mes tickets après réservation ?",
    answer:
      "Tous vos tickets sont accessibles depuis votre espace personnel, dans la section « Mes tickets ». Vous pouvez les consulter à tout moment et retrouver facilement l’ensemble de vos réservations passées et à venir.",
  },
  {
    question: "Comment modifier ou annuler un ticket ?",
    answer:
      "Les conditions de modification ou d'annulation dépendent de la compagnie de transport concernée. Nous vous recommandons de contacter directement le point de vente, le vendeur agréé ou l'agence concernée pour toute demande liée à votre ticket.",
  },
  {
    question: "Comment noter un trajet ?",
    answer:
      "Après votre voyage, une option de notation apparaît dans le détail de votre ticket. Vous pouvez évaluer le confort, la propreté, le chauffeur et le rapport qualité-prix. Ces avis permettent d’aider les autres voyageurs à faire un choix plus éclairé.",
  },
  {
    question: "EasyGO est-il disponible sur mobile ?",
    answer:
      "Oui. L’application EasyGO est disponible sur Android via le Google Play Store. Elle vous permet de rechercher des trajets, consulter vos tickets et gérer votre profil directement depuis votre smartphone.",
  },
  {
    question: "Comment contacter le support EasyGO ?",
    answer:
      "Pour toute question ou difficulté, vous pouvez nous contacter via le formulaire de contact disponible sur le site. Vous pouvez également consulter notre blog pour suivre les dernières actualités et mises à jour de la plateforme.",
  },
  {
    question: "Comment EasyGO compare-t-il les tarifs ?",
    answer:
      "EasyGO enregistre dans sa base de données les informations nécessaires sur les trajets proposés par ses compagnies partenaires. Cela nous permet de vous présenter les différentes options disponibles, avec leurs tarifs et leurs caractéristiques, afin de vous aider à choisir l’offre la plus adaptée à vos besoins.",
  },
]
</script>

<style scoped>
.faq {
  max-width: 1100px;
  width: 100%;
  gap: 2rem;
}

article {
  flex-flow: column wrap;
  width: 100%;
  justify-content: flex-start;
  gap: 0;
}

article h3 {
  border-bottom: 1px solid var(--color-border);
  width: 100%;
  cursor: pointer;
  user-select: none;
}

.faq-body {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    max-height 0.35s ease,
    opacity 0.25s ease;
}

.faq-body.open {
  max-height: 300px;
  opacity: 1;
}

.faq-body p {
  padding-top: 0.5rem;
}
</style>
